import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { canActivateAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { LogoutCallbackComponent } from './components/logout-callback/logout-callback.component';
import { MmpInnerpageComponent } from './components/mmp-innerpage/mmp-innerpage.component';
import { MmpFileUploadComponent } from './components/mmp-file-upload/mmp-file-upload.component';
import { MmpEvalDashboardComponent } from './components/mmp-eval-dashboard/mmp-eval-dashboard.component';
import { roleBasedRedirectGuard } from './guards/role-based-redirect.guard';

export const routes: Routes = [

  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: 'login/callback', component: OktaCallbackComponent },
  { path: '', component: LogoutCallbackComponent },
  { path: 'user-transcripts/:combinedId', canActivate: [canActivateAuthGuard], component: MmpInnerpageComponent },
  { path: 'user-transcripts', canActivate: [canActivateAuthGuard], component: MmpFileUploadComponent },
  { path: 'evaluator-dashboard', canActivate: [canActivateAuthGuard, roleBasedRedirectGuard], component: MmpEvalDashboardComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
